import React, { useState, useEffect, useContext } from 'react'
import {Button, message, Upload} from 'antd'
import { UploadOutlined } from '@ant-design/icons'

const FileUploader = ({ maxNumber, name, uploadHandler }) => {
  const [files, setFiles] = useState([])

  const uploadProps = {
    accept: 'image/jpeg,image/gif,image/png,application/pdf',
    maxCount: maxNumber,

    onRemove: async (file) => {
      const filesClone = [ ...files ]
      const index = filesClone.indexOf(file)
      const newFileList = filesClone.slice()
      newFileList.splice(index, 1)
      if (newFileList.length) {
        await uploadHandler(newFileList)
      }
      setFiles(newFileList)
    },
    beforeUpload: async (file, fileList) => {
      const filesToUpload = [ ...files, ...fileList ]

      if(filesToUpload.length > maxNumber ) {
        message.warning(`Only allow to upload ${maxNumber} files`)
        return false
      }

      await setFiles(filesToUpload)
      await uploadHandler(filesToUpload)

      return false
    },
    fileList: files,
  }

  return (
    <div>
      <Upload {...uploadProps}><Button icon={<UploadOutlined />}>Click to Upload</Button></Upload>
    </div>
  )

}

export default FileUploader